import WiseView from '../../../WiseView.vue';
import { frontendURL } from '../../../../../../helper/URLHelper';
import CreateMessagesWise from './CreateMessagesWise.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/createmessage'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'create_message',
        component: CreateMessagesWise,
        roles: ['administrator'],
      },
    ],
  },
];
